// Using module.exports because this is used in gatsby-node as well
module.exports.getURL = (prefix, title) => {
  const slug = title
    .match(/(\w+)/g)
    .map(word => word.toLowerCase())
    .join('-');
  return `/${prefix}/${slug}`;
};
